module.exports = __webpack_public_path__ + "static/media/gallery.037bd046.png";